import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { map, Subject, takeUntil, takeWhile, timer } from 'rxjs';

@Component({
  selector: 'app-vaids-deadline-modal',
  templateUrl: './vaids-deadline-modal.component.html',
  styleUrls: ['./vaids-deadline-modal.component.css']
})
export class VaidsDeadlineModalComponent implements OnInit, OnDestroy {
  @Input() set deadline(dateString: string) {
    if (!dateString) return;
    
    this.deadlineString = dateString;
    this.deadlineMiliseconds = new Date(dateString).getTime() - Date.now();
    
    // Kill old timer, start fresh
    this._destroy$.next();
    this.initTimer();
  }

  @Output() expired = new EventEmitter<void>();  // Add this
  @Output() continue = new EventEmitter<void>();

  deadlineString = new Date().toISOString();
  deadlineMiliseconds = 0;
  
  private readonly _destroy$ = new Subject<void>();

  get secondsLeft()  { return Math.floor(this.deadlineMiliseconds / 1000); }
  get minutesLeft()  { return Math.floor(this.secondsLeft / 60); }
  get hoursLeft()    { return Math.floor(this.minutesLeft / 60); }
  get daysLeft()     { return Math.floor(this.hoursLeft / 24); }

  // For template display (with modulo)
  get displaySeconds() { return Math.max(0, this.secondsLeft % 60).toString().padStart(2,'0'); }
  get displayMinutes() { return Math.max(0, this.minutesLeft % 60).toString().padStart(2,'0'); }
  get displayHours()   { return Math.max(0, this.hoursLeft % 24).toString().padStart(2,'0'); }
  get displayDays()    { return Math.max(0, this.daysLeft).toString().padStart(2,'0'); }

  constructor(
    private readonly router: Router, 
    private readonly bsModalRef: BsModalRef
  ) {}

  ngOnInit(): void {
    // this.initTimer();
  }

  private initTimer(interval: number = 1000) {
    timer(0, interval).pipe(
      takeUntil(this._destroy$),
      takeWhile(() => this.deadlineMiliseconds > 0, true) // inclusive
    ).subscribe({
      next: () => {
        this.deadlineMiliseconds -= interval;
      },
      complete: () => {
        this.deadlineMiliseconds = 0;
        this.expired.emit();  // Or this.onContinue(), or auto-close
      }
    });
  }

  onClose() {
    this._destroy$.next();  // Stop timer
    this.bsModalRef?.hide();
  }

  onContinue() {
    this._destroy$.next();
    this.continue.emit()
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
